function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from "underscore";
import classNames from "classnames";
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import PropTypes from "prop-types";
import React from "react";
import Checkbox from "./checkbox";
import HighlightText from "../elements/highlight-text";
import AdvancedComboboxItem from "./advanced-combobox-item";
import Icon from "../elements/icon";
import ArrowSelectInput from "../elements/arrow-select-input";
import BasicUtils from "../../utils/basic-utils";
import numeral from "numeral";
var array = PropTypes.array,
    object = PropTypes.object,
    string = PropTypes.string,
    any = PropTypes.any,
    func = PropTypes.func,
    bool = PropTypes.bool,
    oneOfType = PropTypes.oneOfType; // Expects the follow formats:
// For Groups: {label: "Group Label", items: [...]}
// For Items: {label: "Option Label", value: "Option value", icon: "icon-class", disabled: true}

var SEARCH_HEIGHT = 71;
var SELECT_ALL_HEIGHT = 42;
var DEFAULT_MAX_HEIGHT = 720;

var formatterFactory = function formatterFactory(multiple) {
  if (multiple == null) {
    multiple = false;
  }

  var formatter = function formatter(item, isSelected, isHovered, search_query) {
    return /*#__PURE__*/React.createElement("span", {
      className: "et--advanced-combobox-item"
    }, function () {
      if (multiple) {
        return /*#__PURE__*/React.createElement(Checkbox, {
          className: "et--checkbox-small",
          checked: isSelected,
          label: item != null ? item.label : ""
        });
      } else {
        if (isSelected) {
          return /*#__PURE__*/React.createElement(Icon, {
            className: "et--advanced-combobox-item--selected",
            icon: "check"
          });
        }
      }
    }(), /*#__PURE__*/React.createElement(HighlightText, {
      className: "et--advanced-combobox-item--label",
      string: item != null ? item.label : undefined,
      query: BasicUtils.regexEscape(search_query)
    }), item.count || item.icon ? /*#__PURE__*/React.createElement("span", {
      className: "et--advanced-combobox-item--right-area"
    }, item.count ? /*#__PURE__*/React.createElement("span", {
      className: "et--advanced-combobox-item--count"
    }, numeral(item.count).format("0,0")) : undefined, item.icon ? /*#__PURE__*/React.createElement("i", {
      className: classNames("et--advanced-combobox-item--icon", item.icon)
    }) : undefined) : undefined);
  };

  return formatter;
};

var AdvancedComboboxContent = /*#__PURE__*/function (_React$Component) {
  _inherits(AdvancedComboboxContent, _React$Component);

  var _super = _createSuper(AdvancedComboboxContent);

  function AdvancedComboboxContent() {
    var _this;

    _classCallCheck(this, AdvancedComboboxContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      search: _this.props.initial_search || "",
      listScroll: undefined,
      listHeight: undefined,
      selectedIndex: -1
    });

    _defineProperty(_assertThisInitialized(_this), "getSelectable", function () {
      var list = _this.getFilteredList();

      if (_this.props.grouped) {
        return _.flatten(_.pluck(list, "items"));
      } else {
        return list;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getFilteredList", function () {
      if (_this.props.searchable && _this.state.search && !_this.props.onSearch) {
        var query = _this.state.search;

        if (_this.props.grouped) {
          return _.compact(_.map(_this.props.options, function (group) {
            if (BasicUtils.matchesSearchQuery(group.label, query)) {
              return group;
            } else {
              var items = _.filter(group.items, function (item) {
                return BasicUtils.matchesSearchQuery(item.label, query);
              });

              if (!_.isEmpty(items)) {
                return _.extend({}, group, {
                  items: items
                });
              }
            }
          }));
        } else {
          return _.filter(_this.props.options, function (item) {
            return BasicUtils.matchesSearchQuery(item.label, query);
          });
        }
      } else {
        return _this.props.options;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getSelectedItem", function (item, list) {
      if (list == null) {
        list = _this.props.value;
      }

      return _.clone(_.findWhere(list, {
        value: item.value
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "isSelected", function (item) {
      if (_.isUndefined(_this.props.value)) {
        return false;
      }

      if (_this.props.multiple) {
        return !!_this.getSelectedItem(item);
      } else {
        return item.value === (_this.props.value != null ? _this.props.value.value : undefined);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (value, e) {
      if (_this.props.multiple) {
        var values = _.map(_this.props.value, _.clone);

        var found = _this.getSelectedItem(value);

        if (found) {
          values = _.reject(values, function (val) {
            return val.value === found.value;
          });
        } else {
          values.push(value);
        }

        _this.setState({
          listScroll: _this.refs.list_outer.scrollTop,
          listHeight: _this.refs.list_inner.offsetHeight
        });

        if (typeof _this.props.onChange === "function") {
          _this.props.onChange(values, e);
        }
      } else {
        if (typeof _this.props.onChange === "function") {
          _this.props.onChange(value, e);
        }
      }

      if (!_this.props.multiple) {
        _this.setState({
          search: ""
        });

        return typeof _this.props.onComplete === "function" ? _this.props.onComplete() : undefined;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleHover", function (item, index, evt) {
      return _this.setState({
        selectedIndex: index
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyEnter", function () {
      var selectedIndex = _this.state.selectedIndex;

      var selectable_options = _this.getSelectable();

      var selected = selectable_options[selectedIndex];

      if (_.isEmpty(selectable_options) && _.isFunction(_this.props.createFromSearch)) {
        selected = _this.props.createFromSearch(_this.state.search);
      }

      if (selected && !(selected != null ? selected.disabled : undefined)) {
        return _this.handleSelect(selected);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleType", function (query, e) {
      if (query == null) {
        query = "";
      }

      query = query.trim();

      if (typeof _this.props.onSearch === "function") {
        _this.props.onSearch(query);
      }

      return _this.setState({
        search: query,
        selectedIndex: 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectAll", function () {
      var all_values = _.compact(_.map(_this.getSelectable(), function (item) {
        if (!item.disabled) {
          return item;
        }
      }));

      return typeof _this.props.onChange === "function" ? _this.props.onChange(all_values) : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "handleUnselectAll", function () {
      return typeof _this.props.onChange === "function" ? _this.props.onChange([]) : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "renderListItem", function (item, key, index) {
      return /*#__PURE__*/React.createElement(AdvancedComboboxItem, {
        className: _this.props.multiple ? "is-multiple" : undefined,
        item: item,
        key: key,
        isSelected: _this.isSelected(item),
        isFocused: index === _this.state.selectedIndex,
        search: _this.state.search,
        onClick: _this.handleSelect,
        index: index,
        onHover: _this.handleHover,
        formatItem: _this.props.formatItem || formatterFactory(_this.props.multiple)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getHeight", function () {
      var height = _this.props.height;

      if (_this.props.searchable && !_this.props.isOpenedUp) {
        height = height - SEARCH_HEIGHT;
      }

      if (_this.props.multiple && (_this.props.allowChangeAll || _this.props.allowUnselectAll)) {
        height = height - SELECT_ALL_HEIGHT;
      }

      return height || DEFAULT_MAX_HEIGHT;
    });

    return _this;
  }

  _createClass(AdvancedComboboxContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // todo: figure out where focus should actually be called
      if (this.props.searchable) {
        return this.refs.search_box != null ? this.refs.search_box.focus() : undefined;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // If adding/removing data from the list make sure scroll stays put
      if (!_.isUndefined(this.state.listScroll) && this.state.listHeight && this.props.multiple) {
        var new_height = this.refs.list_inner.offsetHeight;
        var new_scroll = this.state.listScroll + (new_height - this.state.listHeight);
        this.refs.list_outer.scrollTop = new_scroll;
        return this.setState({
          listScroll: undefined,
          listHeight: undefined,
          selectedIndex: -1
        });
      }
    } // reset hover

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var selectable = this.getSelectable();
      var list = this.getFilteredList();
      var group_index = -1;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames("et--advanced-combobox-content", this.props.className)
      }, // Search box for searchable select elements
      this.props.searchable ? /*#__PURE__*/React.createElement("div", {
        className: "et--advanced-combobox-content--search"
      }, /*#__PURE__*/React.createElement(ArrowSelectInput, {
        type: "search",
        selectedIndex: this.state.selectedIndex,
        maxIndex: selectable.length - 1,
        placeholder: this.props.search_placeholder,
        defaultValue: this.state.search,
        onType: this.handleType,
        onEnter: this.handleKeyEnter,
        onArrow: function onArrow(i) {
          return _this2.setState({
            selectedIndex: i
          });
        },
        focusOnMount: this.props.focusOnMount
      })) : undefined,
      /*#__PURE__*/
      // List / Grouped List Display
      React.createElement("div", {
        className: classNames("et--advanced-combobox-content--list", {
          "is-grouped": this.props.grouped
        }),
        style: {
          maxHeight: !this.props.mobile ? this.getHeight() : undefined
        },
        onWheel: function onWheel(e) {
          e.stopPropagation();
          return e.nativeEvent.stopImmediatePropagation();
        },
        ref: "list_outer"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "et--advanced-combobox-content--list-inner",
        ref: "list_inner"
      }, _.isEmpty(selectable) && !!this.state.search && _.isFunction(this.props.createFromSearch) ? this.renderListItem(this.props.createFromSearch(this.state.search), this.state.search, 0) : _.isEmpty(selectable) ? /*#__PURE__*/React.createElement("div", {
        className: "et--advanced-combobox-content--text-empty-message"
      }, this.props.empty_placeholder) : _.map(list, function (item, item_index) {
        if (_this2.props.grouped) {
          return /*#__PURE__*/React.createElement("li", {
            className: "et--advanced-combobox-content--group",
            key: item.key || item.value || item_index
          }, /*#__PURE__*/React.createElement("strong", {
            className: "et--advanced-combobox-content--group-label"
          }, // et--advanced-combobox-content--group-label only used for tests
          item != null ? item.label : undefined), /*#__PURE__*/React.createElement("ul", null, _.map(item.items, function (group_item) {
            group_index += 1;
            return _this2.renderListItem(group_item, (item.value || item_index) + group_item.value, group_index);
          })));
        } else {
          return _this2.renderListItem(item, item.value, item_index);
        }
      }), this.props.loading ? /*#__PURE__*/React.createElement("div", {
        className: "et--advanced-combobox-content--loading-overlay"
      }, /*#__PURE__*/React.createElement("li", {
        className: "et--advanced-combobox-content--text-empty-message"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-fw fa-spinner fa-pulse"
      }), "Loading...")) : undefined)), // Check / Uncheck all actions
      function () {
        if (_this2.props.multiple && _this2.props.allowChangeAll) {
          return /*#__PURE__*/React.createElement("div", {
            className: "et--advanced-combobox--selection"
          }, /*#__PURE__*/React.createElement("strong", null, "".concat((_this2.props.value != null ? _this2.props.value.length : undefined) || 0, " selected: ")), /*#__PURE__*/React.createElement("a", {
            className: "et--advanced-combobox--selection-link",
            href: "#",
            onClick: _this2.handleSelectAll
          }, "Select all"), /*#__PURE__*/React.createElement("span", null, " | "), /*#__PURE__*/React.createElement("a", {
            className: "et--advanced-combobox--selection-link",
            href: "#",
            onClick: _this2.handleUnselectAll
          }, "Unselect all")); // advanced-combobox--selection-link only used for test
        } else if (_this2.props.multiple && _this2.props.allowUnselectAll) {
          return /*#__PURE__*/React.createElement("div", {
            className: "et--advanced-combobox--selection"
          }, /*#__PURE__*/React.createElement("strong", null, "".concat((_this2.props.value != null ? _this2.props.value.length : undefined) || 0, " selected: ")), /*#__PURE__*/React.createElement("a", {
            href: "#",
            onClick: _this2.handleUnselectAll
          }, "Unselect all"));
        }
      }());
    }
  }]);

  return AdvancedComboboxContent;
}(React.Component);

_defineProperty(AdvancedComboboxContent, "displayName", "AdvancedComboboxContent");

_defineProperty(AdvancedComboboxContent, "propTypes", {
  options: oneOfType([array, object]),
  name: string,
  value: any,
  onChange: func,
  //
  position: string,
  multiple: bool,
  grouped: bool,
  allowChangeAll: bool,
  allowUnselectAll: bool,
  searchable: bool,
  search_placeholder: string,
  initial_search: string,
  onSearch: func,
  // args: [trimed_query], called on query change
  createFromSearch: func,
  //
  formatItem: func,
  //
  formatSelection: func,
  //
  placeholder: string,
  empty_placeholder: any,
  loading: bool,
  disabled: bool,
  focusOnMount: bool,
  // new stuff...
  isOpenedUp: bool,
  height: any,
  onComplete: func
});

_defineProperty(AdvancedComboboxContent, "defaultProps", {
  options: [],
  multiple: false,
  grouped: false,
  searchable: false,
  search_placeholder: "Search...",
  allowChangeAll: false,
  placeholder: "Select Option...",
  empty_placeholder: "No results",
  formatLabel: function formatLabel(label) {
    return label;
  },
  formatSelection: function formatSelection(selectionText, selection, placeholder, open) {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
      className: "et--advanced-combobox-content--selected-text"
    }, selectionText), open ? /*#__PURE__*/React.createElement(Icon, {
      icon: "chevron-up"
    }) : /*#__PURE__*/React.createElement(Icon, {
      icon: "chevron-down"
    }));
  }
});

export { AdvancedComboboxContent as default };